import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo } from "react";
import LoadingButton from "src/components/Buttons/LoadingButton";
import Review from "src/components/Review";
import { useProduct } from "src/context/ProductProvider";
import { Trans, useTranslation } from "react-i18next";
import { reviews } from "src/constants/reviews";
import Container from "@mui/material/Container";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";

const Reviews = () => {
  const productSlug = useProduct((p) => p.slug);
  const productName = useProduct((p) => p.name);
  const page = "reviews";
  const { submitAnswer } = useSubmitAnswers();
  const { t } = useTranslation();

  const filteredReviews = useMemo(
    () =>
      reviews.filter(
        (review) =>
          review.product?.includes(productSlug) && review.page === page
      ),
    [productSlug]
  );

  const handleContinue = useCallback(() => {
    submitAnswer(["Ignore"]);
  }, [submitAnswer]);

  return (
    <Container maxWidth="sm">
      <Stack gap={3}>
        <Typography variant="h4">
          <Trans i18nKey={`${page}.title`} tOptions={{ productName }}>
            {`With {{productName}}, 1 in 3 adults lost`}{" "}
            <b>20% of their body weight.</b>
          </Trans>
        </Typography>

        {filteredReviews.map((review) => (
          <Review key={review.name} review={review} onNext={handleContinue} />
        ))}

        <LoadingButton loading={false} onClick={handleContinue}>
          {t("button.next", "Next")}
        </LoadingButton>
      </Stack>
    </Container>
  );
};

export default Reviews;
